var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlyssia3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 191.2 320.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-7 {\n        stroke-width: 2.8px;\n      }\n\n      .cls-1, .cls-7, .cls-9 {\n        stroke: #000;\n      }\n\n      .cls-10 {\n        fill: #6e2f22;\n      }\n\n      .cls-11 {\n        fill: #e296cf;\n      }\n\n      .cls-2 {\n        stroke: #6e2f22;\n        stroke-width: 4px;\n      }\n\n      .cls-12 {\n        fill: #260809;\n      }\n\n      .cls-3 {\n        stroke: #000d19;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-width: 3.8px;\n      }\n\n      .cls-13 {\n        opacity: .5;\n      }\n\n      .cls-13, .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: #4d65b4;\n      }\n\n      .cls-16 {\n        fill: #aa3d74;\n        opacity: .4;\n      }\n\n      .cls-17 {\n        fill: #4d1417;\n      }\n\n      .cls-18 {\n        fill: #b7c8d8;\n      }\n\n      .cls-4 {\n        stroke: #f5c13d;\n        stroke-width: 3.1px;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-28 {\n        fill: #e6eef2;\n      }\n\n      .cls-29 {\n        fill: #7bd2e8;\n      }\n\n      .cls-30 {\n        fill: #ffd24a;\n      }\n\n      .cls-31 {\n        fill: #8c432b;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: 11px;\n      }\n\n      .cls-32 {\n        fill: #eb175a;\n      }\n\n      .cls-33 {\n        fill: #000d19;\n      }\n\n      .cls-34 {\n        fill: #8695b2;\n      }\n\n      .cls-35 {\n        fill: #4d9be6;\n      }\n\n      .cls-36 {\n        fill: #073f4a;\n      }\n\n      .cls-37 {\n        fill: #ffae4a;\n      }\n\n      .cls-6 {\n        stroke: #b7c8d8;\n      }\n\n      .cls-38 {\n        fill: #8f005d;\n      }\n\n      .cls-39 {\n        fill: #360b0e;\n      }\n\n      .cls-8 {\n        stroke: #d99037;\n        stroke-width: 2px;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-41 {\n        fill: #002131;\n      }\n\n      .cls-9 {\n        stroke-width: 3px;\n      }\n\n      .cls-42 {\n        fill: #033040;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1311.9,
    y: 62.5,
    width: 21,
    height: 29.5,
    rx: -634.9,
    ry: -634.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1272.2,
    y: 62.5,
    width: 21,
    height: 29.5,
    rx: -615.1,
    ry: -615.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 73,
    y: 66.8,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 112.7,
    y: 66.8,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -623.1,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -290.5,
    ry: -290.5,
    transform: "translate(5.2 69.3) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -583.7,
    y: 70.6,
    width: 21,
    height: 29.5,
    rx: -270.8,
    ry: -270.8,
    transform: "translate(6 64.9) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M-526.1,119.3l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "-527.8 127.3 -530.7 124.4 -534.3 128 -555.1 148.8 -566.3 180.7 -563.4 183.6 -561.2 181.4 -539 159.2 -527.8 127.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-563.3 176.2 -553.4 148.3 -533.6 128.5 -543.5 156.3 -563.3 176.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M-539,159.2l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "alyssia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -647.7,
    cy: 23.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -634.1,
    cy: 16.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -658.1,
    cy: 31.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -666.3,
    cy: 41.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -673.6,
    cy: 52,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -677.3,
    cy: 65,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -679.8,
    cy: 78.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -681.3,
    cy: 91.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -681.2,
    cy: 103,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -560.9,
    cy: 33,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -572.7,
    cy: 23.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -552.6,
    cy: 43.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -546.8,
    cy: 54.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -542.1,
    cy: 66.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -541.4,
    cy: 80.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -541.9,
    cy: 93.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -543.3,
    cy: 106.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -546.1,
    cy: 118.3,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-609.6,7.3h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z",
    transform: "translate(3.4 68.9) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-1282.5,293.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M-1292.3,281.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-2552.3 581.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -1283.3,
    y: 207.7,
    width: 17.6,
    height: 14,
    transform: "translate(-2549 429.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-1274.5,188c6.8,0,12.4-5.5,12.4-12.4v-28.7c0-6.8-5.5-12.4-12.4-12.4-6.8,0-12.4,5.5-12.4,12.4v28.7c0,6.8,5.5,12.4,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-1286.9,176v30.4c0,1.8,1.5,3.2,3.2,3.2h18.2c1.8,0,3.2-1.5,3.2-3.2v-30.8c0-7-5.9-12.7-13-12.3s-11.8,6-11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -1269.3,
    cy: 221.7,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -1297.3,
    y: 269.2,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-1308.5,262.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-1308.5,307c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-1282.5,248.6c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-1302,183.3h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M-1293.4,191.2h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-1312.3,137.2h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -1308.7,
    y: 123.2,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-1311.9,124.8h29.1c2.4,0,4.4,2,4.4,4.4v12.7h-37.8v-12.7c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M-1318.3,294.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-2604.3 608.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -1323.3,
    y: 282.7,
    width: 29.7,
    height: 22.5,
    transform: "translate(-2616.9 587.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1342.7,
    cy: 23.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1330,
    cy: 15.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1352.1,
    cy: 33.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1359.2,
    cy: 44,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1365.2,
    cy: 55.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1367.5,
    cy: 68.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1368.5,
    cy: 82.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1368.5,
    cy: 95.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1367,
    cy: 106.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1255.4,
    cy: 23.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1268.1,
    cy: 15.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1246,
    cy: 33.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1238.9,
    cy: 44,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1232.9,
    cy: 55.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1230.7,
    cy: 68.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1229.6,
    cy: 82.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1229.6,
    cy: 95.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1231.1,
    cy: 106.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-1300.2,3.4h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -1246.3,
    cy: 77.4,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -1336.8,
    cy: 77.4,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-1303.9-1.2h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-1245.2,86c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-1336.8,86c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5c6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-1304.1,35.7h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M-1273.5,105.8c1.8,0,3,1.9,2.1,3.5-2.5,4.5-7.2,7.6-12.8,7.6s-10.3-3.1-12.8-7.6.3-3.5,2.1-3.5h21.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1311.9,
    y: 62.5,
    width: 21,
    height: 29.5,
    rx: -634.9,
    ry: -634.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -1304,
    y: 70.9,
    width: 11.7,
    height: 19.6,
    rx: -640.3,
    ry: -640.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1304.9,
    y: 67.8,
    width: 6.4,
    height: 11.7,
    rx: -646.1,
    ry: -646.1
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-1311.9,73.3v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -1315.4,
    y1: 69.7,
    x2: -1311.6,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -1314,
    y1: 65.7,
    x2: -1310.5,
    y2: 67.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-1316.2,85.3h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -1315.9,
    cy: 97.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1272.2,
    y: 62.5,
    width: 21,
    height: 29.5,
    rx: -615.1,
    ry: -615.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -1265,
    y: 70.9,
    width: 11.7,
    height: 19.6,
    rx: -620.8,
    ry: -620.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1265.9,
    y: 67.8,
    width: 6.4,
    height: 11.7,
    rx: -626.6,
    ry: -626.6
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-1251.2,73.3v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -1247.7,
    y1: 69.7,
    x2: -1251.4,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -1249.1,
    y1: 65.7,
    x2: -1252.6,
    y2: 67.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-1255.8,85.3h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(-2507.8 185.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -1250.3,
    cy: 96.5,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-1268.4,69.5h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-1311.3,69.5h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-1286.3,79s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M-1281.1,80.7v15.3c0,2.2,1.8,4,4,4h2.4c3,0,5-3.2,3.6-5.9l-7.2-14.1c-.7-1.4-2.8-.9-2.8.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-1324,38.4h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1321.5,
    cy: 46.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1322.2,
    cy: 41.6,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1314.8,
    cy: 39.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1305.1,
    cy: 34.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 56.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 66.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 75.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 103.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 112.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 121.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 84.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1325.6,
    cy: 94,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-1235.7,36.4h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(-2484.5 162.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1252.6,
    cy: 44.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1259.2,
    cy: 37.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1269,
    cy: 32.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 54.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 64.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 73.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 101.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 110.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 119.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 82.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -1248.5,
    cy: 92,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -1332.4,
    y: 220.6,
    width: 17.6,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-1323.6,201c-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4s12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-1311.2,189v30.4c0,1.8-1.5,3.2-3.2,3.2h-18.2c-1.8,0-3.2-1.5-3.2-3.2v-30.8c0-7,5.9-12.7,13-12.3,6.6.3,11.8,6,11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -1328.8,
    cy: 234.6,
    r: 14
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: -1295.5,
    y1: 211.2,
    x2: -1295.5,
    y2: 280.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M102.4,293.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M92.6,281.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(217.5 581.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 155.6,
    y: 143.6,
    width: 17.6,
    height: 14,
    transform: "translate(239.3 -59.4) rotate(67.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M137.2,174.3c4.8-4.8,4.8-12.7,0-17.5l-20.3-20.3c-4.8-4.8-12.7-4.8-17.5,0-4.8,4.8-4.8,12.7,0,17.5l20.3,20.3c4.8,4.8,12.7,4.8,17.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M133.6,177l28-11.8c1.7-.7,2.4-2.6,1.7-4.3l-7.1-16.8c-.7-1.7-2.6-2.4-4.3-1.7l-28.4,11.9c-6.5,2.7-9.4,10.3-6.3,16.7,2.9,6,10.1,8.5,16.3,5.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 168.8,
    cy: 143.1,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 87.6,
    y: 269.2,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M76.4,262.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M76.4,307c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M102.4,248.6c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M82.9,183.3h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M91.5,191.2h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M72.6,137.2h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 76.2,
    y: 123.2,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M72.8,131.2h29.1c2.4,0,4.4,2,4.4,4.4v6.4h-37.8v-6.4c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M66.6,294.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(165.5 608.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 61.6,
    y: 282.7,
    width: 29.7,
    height: 22.5,
    transform: "translate(152.9 587.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 42.1,
    cy: 28.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 54.9,
    cy: 20.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 32.8,
    cy: 37.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 25.7,
    cy: 48.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 19.6,
    cy: 59.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 17.4,
    cy: 73.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 16.4,
    cy: 86.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 16.4,
    cy: 99.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 17.9,
    cy: 111.3,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 129.5,
    cy: 28.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 116.7,
    cy: 20.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 138.9,
    cy: 37.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 146,
    cy: 48.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 152,
    cy: 59.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 154.2,
    cy: 73.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 155.3,
    cy: 86.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 155.3,
    cy: 99.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 153.8,
    cy: 111.3,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M84.7,7.8h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1H32.7c-12.2,0-22.1-9.9-22.1-22.1v-19.2C10.6,41,43.8,7.8,84.7,7.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 138.6,
    cy: 81.8,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 48.1,
    cy: 81.8,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M81,3.1h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7H48.7c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.7,90.4c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M159.1,71.6c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 116.7,
    y: 63.3,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.6,
    y: 70.8,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.1,90.4c-6.4,0-11.5,5.2-11.5,11.5,0,6.4,5.2,11.5,11.5,11.5,6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M80.8,40h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.1,113.2c-5.7,2.8-12.2,2.1-17-1.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 73,
    y: 66.8,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 80.9,
    y: 75.3,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 80,
    y: 72.2,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73,77.7v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.5,
    y1: 74.1,
    x2: 73.2,
    y2: 75.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70.9,
    y1: 70.1,
    x2: 74.4,
    y2: 71.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M68.7,89.7h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 73.3,
    cy: 102.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 112.7,
    y: 66.8,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 119.8,
    y: 75.3,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 118.9,
    y: 72.2,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.7,77.7v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.2,
    y1: 74.1,
    x2: 133.5,
    y2: 75.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.8,
    y1: 70.1,
    x2: 132.3,
    y2: 71.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M129.1,89.7h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(262 194.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 134.6,
    cy: 101.1,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M116.5,73.9h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.6,73.9h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.6,83.4s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M104.1,87.1v14c0,2,1.8,3.7,4.1,3.7h2.5c3.1,0,5.1-2.9,3.7-5.4l-7.3-12.9c-.7-1.3-2.9-.8-2.9.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 89.4,
    y1: 211.2,
    x2: 89.4,
    y2: 280.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-598.9,293.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M-608.7,281.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-1185.2 581.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -555.4,
    y: 133,
    width: 17.6,
    height: 14,
    transform: "translate(-93.4 476.2) rotate(50.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-569.2,174.2c5.3-4.3,6.1-12.1,1.8-17.4l-18.1-22.3c-4.3-5.3-12.1-6.1-17.4-1.8-5.3,4.3-6.1,12.1-1.8,17.4l18.1,22.3c4.3,5.3,12.1,6.1,17.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-568.9,174l23.6-19.2c1.4-1.1,1.6-3.2.5-4.6l-11.5-14.1c-1.1-1.4-3.2-1.6-4.6-.5l-23.9,19.4c-5.5,4.4-6.2,12.5-1.4,17.8,4.4,5,12.1,5.3,17.3,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -544.5,
    cy: 131.6,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -613.7,
    y: 269.2,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-624.9,262.1c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-624.9,307c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-598.9,248.6c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M-618.5,183.3h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M-609.5,194.1h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-628.8,137.2h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -625.1,
    y: 123.2,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M-625.6,127.4h26.1c2.4,0,4.4,2,4.4,4.4v10.2h-34.9v-10.2c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M-634.7,294.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(-1237.2 608.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -639.7,
    y: 282.7,
    width: 29.7,
    height: 22.5,
    transform: "translate(-1249.8 587.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -557.9,
    cy: 87.2,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -647.8,
    cy: 77.1,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-610.7,3.1h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z",
    transform: "translate(.9 68.1) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-557.7,95.9c6.3.7,10.9,6.4,10.1,12.7s-6.4,10.9-12.7,10.1-10.9-6.4-10.1-12.7,1.6-5.2,3.5-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-648.7,85.6c-6.3-.7-12,3.8-12.7,10.1s3.8,12,10.1,12.7,12-3.8,12.7-10.1c.3-2.8-.4-5.5-1.8-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-615.8,40.4h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z",
    transform: "translate(5.8 68.2) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M-588.1,112.4c1.8.2,2.8,2.2,1.7,3.7-2.9,4.2-8.1,6.7-13.5,6.1s-9.9-4.2-11.8-9,.7-3.4,2.5-3.2l21.1,2.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -623.1,
    y: 66.1,
    width: 21,
    height: 29.5,
    rx: -290.5,
    ry: -290.5,
    transform: "translate(5.2 69.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -615.7,
    y: 77.2,
    width: 11.7,
    height: 19.6,
    rx: -296.1,
    ry: -296.1,
    transform: "translate(5.9 69) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -615.7,
    y: 73.7,
    width: 6.4,
    height: 11.7,
    rx: -301.5,
    ry: -301.5,
    transform: "translate(5.1 69.3) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-622.6,75.8v-.2c.7-5.8,5.9-9.9,11.7-9.3h0c5.8.7,9.9,5.9,9.3,11.6v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -625.7,
    y1: 71.8,
    x2: -622.1,
    y2: 73.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -623.8,
    y1: 68,
    x2: -620.5,
    y2: 70.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-629.1,87.6h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z",
    transform: "translate(6.7 70.8) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -583.7,
    y: 70.6,
    width: 21,
    height: 29.5,
    rx: -270.8,
    ry: -270.8,
    transform: "translate(6 64.9) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -577.3,
    y: 81.8,
    width: 11.7,
    height: 19.6,
    rx: -276.9,
    ry: -276.9,
    transform: "translate(6.7 64.7) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -577.3,
    y: 78.4,
    width: 6.4,
    height: 11.7,
    rx: -282.3,
    ry: -282.3,
    transform: "translate(5.8 65) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-562.3,82.6v-.2c.7-5.8-3.5-11-9.3-11.6h0c-5.8-.7-11,3.5-11.6,9.3v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -558.4,
    y1: 79.4,
    x2: -562.3,
    y2: 80.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: -559.4,
    y1: 75.3,
    x2: -563,
    y2: 76.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M-569.1,94.1h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(-1142.2 139.3) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -565,
    cy: 106.3,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: -624.6,
    cy: 100.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-580.5,77.8h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(6.5 64.8) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-623.1,73h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(5.7 69.5) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-597.8,84.3s1.6-2.7,5.5-2.2,4.9,3.6,4.9,3.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M-592.8,86.5l-1.6,14.3c-.2,2.1,1.3,3.9,3.4,4.2l2.3.3c2.9.3,5.1-2.4,4-5.1l-5.3-13.9c-.5-1.4-2.6-1.1-2.8.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-625.3,37.6h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z",
    transform: "translate(5.2 71.8) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -618.7,
    cy: 47.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -618.8,
    cy: 42.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -611.3,
    cy: 41.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -601,
    cy: 37.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -623.8,
    cy: 56.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -625,
    cy: 66.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -626,
    cy: 75.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -629.1,
    cy: 103.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -630.1,
    cy: 112.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -631.2,
    cy: 121.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -627,
    cy: 84.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -628.1,
    cy: 94,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-547.8,46.7h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(-1115.4 120.2) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -560.5,
    cy: 53.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -566.3,
    cy: 46.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -575.4,
    cy: 40.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -557.5,
    cy: 64.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -558.6,
    cy: 74.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -559.7,
    cy: 83.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -562.7,
    cy: 110.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -563.8,
    cy: 119.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -564.8,
    cy: 128.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -560.7,
    cy: 92.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: -561.7,
    cy: 101.5,
    r: 6.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: -611.9,
    y1: 211.2,
    x2: -611.9,
    y2: 280.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M-526.1,119.3l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M-555.3,149.4l2.4-7.4,24.1-24.1c.1-.1.4,0,.3.2l-2.5,7-24.4,24.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "-527.8 127.3 -530.7 124.4 -534.3 128 -555.1 148.8 -566.3 180.7 -563.4 183.6 -561.2 181.4 -539 159.2 -527.8 127.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "-566.3 180.7 -556.9 150.7 -530.7 124.4 -541.9 156.3 -566.3 180.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-563.3 176.2 -553.4 148.3 -533.6 128.5 -543.5 156.3 -563.3 176.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "-561.2 169.2 -559.1 162.9 -534.1 131.9 -536.3 138.4 -561.2 169.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "-564.7 178.4 -562.6 173 -537.1 141.4 -539.5 147.1 -564.7 178.4"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M-539,159.2l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M-567.7,184.5l1.2-3.5,24.7-24.7-1.7,4.8c-.7,2-1.8,3.7-3.3,5.2l-19.2,19.2c-.7.7-2,0-1.6-1Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -540.9,
    cy: 131.3,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-270.9 -355.5) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -539.4,
    cy: 130.8,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-270.1 -354.5) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -540.4,
    cy: 132.8,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-271.8 -354.6) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -541.8,
    cy: 133.1,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(-272.5 -355.5) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -550.5,
    cy: 166.1,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-299.6 -351.3) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -548.6,
    cy: 165.6,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-298.6 -350.1) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -549.7,
    cy: 167.8,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-300.6 -350.2) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -551.6,
    cy: 168.3,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(-301.6 -351.3) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: -554.9,
    cy: 171.6,
    rx: 2.3,
    ry: 1,
    transform: "translate(-305 -352.7) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -555.6,
    cy: 170.9,
    rx: 2.3,
    ry: 1,
    transform: "translate(-304.8 -353.5) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: -535.9,
    cy: 127.3,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(-266.3 -353) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: -536.7,
    cy: 126.5,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(-266 -353.9) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M-541.7,164.5l-1.7-1.6,1.7-5,.6-.4,1.6,1.6s-1.1,3.3-1.3,4.1c-.4,1.2-.8,1.3-.8,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M-543.4,162.9l1.7-5,.6-.4s-1.1,3.3-1.3,4.1c-.3,1.1-.9,1.3-.9,1.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M-528.1,126l-1.7-1.6,1.9-5.7,1.4,1.4c.3.3.4.8.3,1.2l-1.4,4.3-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M-529.8,124.4l1.9-5.7s.4.3.2.9-1.5,4.4-1.5,4.4l-.6.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "-528.1 126 -529.8 124.4 -529.2 123.9 -527.5 125.6 -528.1 126"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -578.3,
    y: 177.5,
    width: 17.6,
    height: 14,
    transform: "translate(-754 -385) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-599.8,193c-4.8,4.8-12.7,4.8-17.5,0l-20.3-20.3c-4.8-4.8-4.8-12.7,0-17.5s12.7-4.8,17.5,0l20.3,20.3c4.8,4.8,4.8,12.7,0,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M-608.2,172.1h30.4c1.8,0,3.2,1.5,3.2,3.2v18.2c0,1.8-1.5,3.2-3.2,3.2h-30.8c-7,0-12.7-5.9-12.3-13s6-11.8,12.7-11.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: -562.9,
    cy: 179.3,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.3,59.7v-5.2c0-19.6-15.9-35.6-35.6-35.6h-9.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M64.6,74.5c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 22.2,
    y: 66.2,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30,
    y: 73.7,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.3,86.9v-31.1c0-20.3,16.5-36.8,36.8-36.8h27.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M71.1,40.8h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 73.7,
    cy: 48.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 73,
    cy: 44,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 80.3,
    cy: 42,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 90.1,
    cy: 37.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 58.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 68.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 78.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 105.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 114.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 123.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 87.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.6,
    cy: 96.4,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M149.2,40.8h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(285.3 171.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 132.3,
    cy: 48.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 125.7,
    cy: 42,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 115.9,
    cy: 37.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 58.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 68.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 78.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 105.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 114.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 123.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 87.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.4,
    cy: 96.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 132.3,
    cy: 44,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 39.4,
    y: 95.6,
    width: 17.6,
    height: 14,
    transform: "translate(154.9 141.1) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M75.8,118.2c6.8,0,12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M66.8,138.7l-21.5-21.5c-1.3-1.3-1.3-3.3,0-4.6l12.9-12.9c1.3-1.3,3.3-1.3,4.6,0l21.8,21.8c5,5,4.8,13.1-.4,17.9-4.9,4.5-12.6,4-17.3-.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 47,
    cy: 94,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M40.4,14.6l1.6,21.8,22.9-13.2-18.1-12.3c-2.9-2-6.7.3-6.5,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45.6,19.9l.4,7.7c0,1.7,2,2.8,3.5,1.9l6.1-3.5c1.5-.9,1.6-3,0-4l-6.5-4.2c-1.6-1-3.7.2-3.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M140.9,10.3l-19.9,8.9,20.3,17.1,5.4-21.2c.9-3.4-2.6-6.2-5.7-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M137.8,17.4l-6.7,3.8c-1.5.9-1.6,3-.1,4l5.9,3.8c1.5.9,3.4,0,3.6-1.7l.7-7.7c.2-1.9-1.8-3.2-3.5-2.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlyssia3);
export default __webpack_public_path__ + "static/media/alyssia_3.4618da02f3f07d565b77339802625378.svg";
export { ForwardRef as ReactComponent };